// A user-facing timesheet number.
//
// The database `id` is a single global auto-increment across every timesheet in
// the system, so it must never be shown as a business number (a first timesheet
// can read as "205"). This returns the per-run `sequence` (1 for the first
// timesheet of a billing run, 2 for the next, ...) or empty when the timesheet
// was created outside a run — callers render the period instead (#132).
export function timesheetNo(ts) {
  if (!ts || ts.sequence == null) return '';
  return `${ts.sequence}`;
}
